<template>
    <div class="d-flex align-items-center my-1">
        <div><clock-icon :size="oneline ? '18' : '26'" /></div>
        <div v-if="oneline" class="text">{{day}} {{time}}</div>
        <div v-else class="text">{{day}}<br />{{time}}</div>
    </div>
</template>

<script>
export default {
    props: { oneline: { type: Boolean, default: false }},
    data: () => ({ day: '-', time: '-', int: 0 }),
    created () {
        this.int = setInterval(() => {
            let now = new Date();
            this.day = now.toLocaleDateString();
            this.time = now.toLocaleTimeString();
        }, 500);
    },
    beforeDestroy () {
        clearInterval(this.int);
    }
}
</script>

<style scoped>
    .text {
        line-height: 12px;
        font-size: 10px;
        text-align: center;
        padding-left: 4px;
        font-family: monospace;
    }
</style>
